import React from 'react';

function SearchIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4032 13.2318L19.5178 17.3463C19.8137 17.6423 19.9617 18.0023 19.9616 18.4259C19.9616 18.8418 19.8095 19.2017 19.5058 19.5055C19.2021 19.8093 18.842 19.9613 18.4262 19.9613C17.9939 19.9613 17.6345 19.8093 17.3466 19.5055L13.232 15.4029C11.8005 16.3944 10.205 16.8905 8.44534 16.8905C7.30181 16.8905 6.20819 16.6686 5.16445 16.2248C4.12084 15.7808 3.22101 15.1811 2.46525 14.4251C1.70941 13.6694 1.10958 12.7698 0.665798 11.7262C0.221933 10.6823 0 9.58895 0 8.44542C0 7.30181 0.221933 6.20819 0.665798 5.16445C1.10962 4.12084 1.70941 3.22101 2.46525 2.46525C3.22101 1.7095 4.12067 1.10962 5.16445 0.66584C6.20807 0.221933 7.30181 0 8.44534 0C9.58895 0 10.6826 0.221933 11.7265 0.66584C12.7701 1.10962 13.6696 1.7095 14.4254 2.46525C15.1811 3.22101 15.781 4.12067 16.2247 5.16445C16.6688 6.20807 16.8908 7.30181 16.8908 8.44542C16.8908 10.2047 16.3947 11.8004 15.4032 13.2318ZM8.44534 13.8195C9.925 13.8195 11.1905 13.2936 12.2421 12.2418C13.2938 11.1902 13.8198 9.92483 13.8198 8.44517C13.8198 6.96576 13.2939 5.70004 12.2421 4.64853C11.1903 3.59697 9.92483 3.07097 8.44534 3.07097C6.96592 3.07097 5.70021 3.59676 4.6487 4.64853C3.5971 5.70004 3.07113 6.96576 3.07113 8.44517C3.07113 9.92483 3.59697 11.1902 4.6487 12.2418C5.70042 13.2935 6.96592 13.8195 8.44534 13.8195Z"
        fill="#95A1B4"
      />
    </svg>
  );
}

export default SearchIcon;
